/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { DateRestrictionType } from '../models/date-restriction-type';
import { DateRestrictionUnit } from '../models/date-restriction-unit';
import { DateSpecificityType } from '../models/date-specificity-type';
export interface DateRestriction {
  max?: number | null;
  maxUnit?: DateRestrictionUnit;
  min?: number | null;
  minUnit?: DateRestrictionUnit;
  specificity?: DateSpecificityType;
  type?: DateRestrictionType;
}

export class DateRestriction {
  max?: number | null;
  maxUnit?: DateRestrictionUnit;
  min?: number | null;
  minUnit?: DateRestrictionUnit;
  specificity?: DateSpecificityType;
  type?: DateRestrictionType;

  constructor(value: DateRestriction) {
    this.max = value?.max;
    this.maxUnit = value?.maxUnit ? Object.entries(Object.values(DateRestrictionUnit)).flatMap((x) => x).find(x => x === value.maxUnit) as DateRestrictionUnit : undefined;
    this.min = value?.min;
    this.minUnit = value?.minUnit ? Object.entries(Object.values(DateRestrictionUnit)).flatMap((x) => x).find(x => x === value.minUnit) as DateRestrictionUnit : undefined;
    this.specificity = value?.specificity ? Object.entries(Object.values(DateSpecificityType)).flatMap((x) => x).find(x => x === value.specificity) as DateSpecificityType : undefined;
    this.type = value?.type ? Object.entries(Object.values(DateRestrictionType)).flatMap((x) => x).find(x => x === value.type) as DateRestrictionType : undefined;
  }
}
